import React from "react"
import Gallery from "react-grid-gallery";
import Button from 'react-bootstrap/Button';


import vanilla from "../images/smkarten/in.bmp"
import first from "../images/smkarten/1.png"
import second from "../images/smkarten/2.png"
import fourth from "../images/smkarten/4.png"
import five from "../images/smkarten/5.png"
import six from "../images/smkarten/6.png"
import seven from "../images/smkarten/7.png"
import eight from "../images/smkarten/8.png"
import nine from "../images/smkarten/9.png"
import ten from "../images/smkarten/10.png"
import eleven from "../images/smkarten/11.png"
import twelfe from "../images/smkarten/12.png"



import { Container, Row, Col,Div } from "react-bootstrap";
const w = 400;
const h = 400;


const IMAGES = [
  {
    src: first,
    thumbnail:
      first,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "cave "
  },

  {
    src: second,
    thumbnail:
      second,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "cave "
  },
  {
    src: six,
    thumbnail:
    six,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "Angry"
  },
  {
    src: fourth,
    thumbnail:
      fourth,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "nice"
    
  },

  {
    src: five,
    thumbnail:
      five,
    thumbnailWidth: w,
    thumbnailHeight: h
  },
  {
    src: seven,
    thumbnail:
      seven,
    thumbnailWidth: w,
    thumbnailHeight: h
  },
  {
    src: eight,
    thumbnail:
      eight,
    thumbnailWidth: w,
    thumbnailHeight: h
  },
  {
    src: nine,
    thumbnail:
      nine,
    thumbnailWidth: w,
    thumbnailHeight: h
  },
  {
    src: ten,
    thumbnail:
      ten,
    thumbnailWidth: w,
    thumbnailHeight: h
  },

  {
    src: eleven,
    thumbnail:
    eleven,
    thumbnailWidth: w,
    thumbnailHeight: h
  },



];


const Fiddle = () => {
  return (
    <><>
<Container>
      <div class="p-5 mb-4 lc-block">
        <div class="lc-block mb-4">
          <div editable="rich">
            <h2 class="logo" >SAMMELKARTEN</h2>
          </div>
        </div>
        <div class="lc-block mb-1">


          <p class="lead">Using Gmic and Python to create abstract images using randomised values</p>
          <button><a href="https://github.com/hx-ux/SammelKarten">Github</a></button>
{/* 
          <div className="d-grid gap-2">
  <Button variant="primary" size="lg">
    Block level button
  </Button>
  <Button variant="secondary" size="lg">
    Block level button
  </Button>
</div> */}
          <p class="lead">
          </p>
        </div>

      </div>
      <h2 class="text-light">Input Image</h2>
      {/* <img src="{{third}" class="shadow-1-strong rounded mb-4  "> </img> */}
      <img src={vanilla} />
      </Container>
    </><Container>
        <Row>
          <Col> 
          
          <p class="lead">Results</p>
     
          </Col>
          <Col> <div style={{}}>
            <Gallery
              images={IMAGES}
              enableLightbox={true}
              backdropClosesModal />
          </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
      <br></br>
      <br></br>
      </>
  )
}

export default Fiddle
